import { render, staticRenderFns } from "./create_user.vue?vue&type=template&id=5ef0699a&scoped=true&"
import script from "./create_user.vue?vue&type=script&lang=js&"
export * from "./create_user.vue?vue&type=script&lang=js&"
import style0 from "./create_user.vue?vue&type=style&index=0&id=5ef0699a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef0699a",
  null
  
)

export default component.exports